import { Grid, Typography } from '@mui/material';
import React from 'react';
import { containerStyle } from './styles/common';
import strings from './localization';

export function ErrorMessage() {
    return (<Grid container className='mainContainer' sx={containerStyle}>
        <Grid item xs={12}>
            <Typography variant="h6">{strings.anerroroccured}</Typography>
        </Grid>

        <Grid item xs={12}>
            <Typography variant="body1">{strings.sorry}</Typography>
        </Grid>
    </Grid>);
}
